import Skeleton from "plos/src/components/Skeleton/Skeleton";
import { vars } from "plos/src/styles";
import { useTranslation } from "react-i18next";
import {
  listItemStyles,
  matchEntryAndScore,
  matchItemContent,
} from "../MatchItem/matchItem.css";
import {
  matchContentSkel,
  teamAndManagerSkelWrapper,
} from "./matchItemSkeleton.css";

const MatchItemSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div
      className={listItemStyles.default}
      aria-label={t("matchLoading", "match loading")}
    >
      <div className={matchItemContent}>
        <Skeleton width="50px" height="14px" />
        <div className={matchContentSkel}>
          <div className={matchEntryAndScore}>
            <div className={teamAndManagerSkelWrapper}>
              <Skeleton width="100px" height="14px" />
              <Skeleton width="100px" height="14px" />
            </div>
            <Skeleton width="68px" height="34px" borderRadius={vars.radii.xs} />
            <div className={teamAndManagerSkelWrapper}>
              <Skeleton width="100px" height="14px" />
              <Skeleton width="100px" height="14px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MatchItemSkeleton;
